import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { Tabs, Text } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var getActiveTab = function getActiveTab(list) {
  var activeTab = list.find(function (item) {
    return item.isActive;
  });
  return activeTab === null || activeTab === void 0 ? void 0 : activeTab.id;
};
export var TypesOptionsSection = function TypesOptionsSection(_ref) {
  var size = _ref.size,
    types = _ref.types,
    onChangeType = _ref.onChangeType;
  var onClick = useCallback(function (slug) {
    if (onChangeType) {
      onChangeType(slug);
    }
  }, [onChangeType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, types.map(function (_ref2) {
    var list = _ref2.list,
      title = _ref2.title;
    return /*#__PURE__*/React.createElement("div", {
      className: cx('section', "section--".concat(size))
    }, title && /*#__PURE__*/React.createElement(Text, {
      size: "size5-r-s"
    }, title), !!(list !== null && list !== void 0 && list.length) && /*#__PURE__*/React.createElement("div", {
      className: cx('wrapper')
    }, /*#__PURE__*/React.createElement(Tabs, {
      noWrap: true,
      onChange: onClick,
      selectedTab: getActiveTab(list || []),
      tabs: list || [],
      variant: "plain"
    })));
  }));
};